import { ref, watch } from "vue"

interface TotpSetupModalOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

const isModalVisible = ref(false)
let resolvePromise: ((success: boolean) => void) | null = null
let rejectPromise: ((error: Error) => void) | null = null

function handleSuccess() {
	if (resolvePromise) {
		resolvePromise(true)
		resolvePromise = null
		rejectPromise = null
	}
}

function handleError(error: Error) {
	if (rejectPromise) {
		rejectPromise(error)
		resolvePromise = null
		rejectPromise = null
	}
}

function closeModal() {
	isModalVisible.value = false
}

watch(isModalVisible, newVal => {
	if (!newVal && rejectPromise) {
		handleError(new Error("TOTP setup closed"))
	}
})

export function useTotpSetupModal() {
	const showModal = (options?: TotpSetupModalOptions): Promise<boolean> => {
		isModalVisible.value = true

		return new Promise<boolean>((resolve, reject) => {
			resolvePromise = (success: boolean) => {
				if (success) {
					options?.onSuccess?.()
					resolve(success)
				} else {
					options?.onError?.(new Error("TOTP setup cancelled"))
					reject(new Error("TOTP setup cancelled"))
				}
			}

			rejectPromise = (error: Error) => {
				options?.onError?.(error)
				reject(error)
			}
		})
	}

	return {
		isModalVisible,
		showModal,
		handleSuccess,
		handleError,
		closeModal
	}
}
